import { FETCH_MODULE, CREATE_MODULE, UPDATE_MODULE, DELETE_MODULE, GET_MODULE, FETCH_MODULE_SORTED } from 'actions/module';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  modules: [],
};

const moduleReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_MODULE.REQUEST:
    case FETCH_MODULE_SORTED.REQUEST:
    case GET_MODULE.REQUEST:
    case CREATE_MODULE.REQUEST:
    case UPDATE_MODULE.REQUEST:
    case DELETE_MODULE.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_MODULE_SORTED.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        sortedModules: payload,
      };
    }

    case FETCH_MODULE.SUCCESS: {
      const { results, ...rest } = payload;
      return {
        ...state,
        isLoading: false,
        modules: results,
        ...rest,
      };
    }

    case GET_MODULE.SUCCESS: {
      return {
        ...state,
        moduleDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_MODULE.SUCCESS: {
      toast.success('Module added successfully');
      return {
        ...state,
        modules: _.concat(state.modules, payload),
        isLoading: false,
      };
    }

    case UPDATE_MODULE.SUCCESS: {
      toast.success('Module updated successfully');
      delete state.moduleDetail;

      return {
        ...state,
        isLoading: false,
        modules: state.modules.map((data) => {
          if (data.id === payload.id) {
            return payload;
          } else {
            return data;
          }
        }),
      };
    }

    case DELETE_MODULE.SUCCESS: {
      toast.success('Module deleted successfully');
      return {
        ...state,
        isLoading: false,
        modules: state.modules.filter((data) => data.id !== payload),
      };
    }

    case FETCH_MODULE_SORTED.FAIL:
    case FETCH_MODULE.FAIL:
    case GET_MODULE.FAIL:
    case CREATE_MODULE.FAIL:
    case UPDATE_MODULE.FAIL:
    case DELETE_MODULE.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return {
        ...state,
      };
  }
};
export default moduleReducer;
